(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/playtogether-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/playtogether-selector.js');

'use strict';

const {
  events
} = svs.numbergames.accountSelector.constants;
svs.numbergames.game.views.PlayTogetherSelector = Marionette.View.extend({
  syndicates: [],
  ui: {
    teamSelector: '#teamSelector'
  },
  triggers: {
    'change @ui.teamSelector': 'changeTeam'
  },
  modelEvents: {
    'change:isSubscription': 'onChangeIsSubscription'
  },
  className: () => 'playtogether-selector',
  getTemplate() {
    return this.syndicates.length > 1 ? svs.numbergames.game.templates.playtogether_selector : false;
  },
  templateContext() {
    const teams = this.syndicates;
    const currentSyndicateId = svs.utils.paramHandler.get({
      key: 'syndicateId'
    }).value || this.model.get('syndicateId');
    if (currentSyndicateId) {
      teams.forEach(team => {
        team.selected = team.syndicateId === currentSyndicateId;
      });
    }
    return {
      teams
    };
  },
  async initialize() {
    if (svs.numbergames.game.utils.isSelfService() || !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      return;
    }
    this.accountSelectorEvents = {
      [events.ACTIVE_ACCOUNT_CHANGED]: this.updateSyndicate.bind(this)
    };
    svs.numbergames.accountSelector.on(this.accountSelectorEvents, this);
    try {
      const activeAccount = await svs.numbergames.accountSelector.getActiveAccount();
      const syndicateId = svs.utils.paramHandler.get({
        key: 'syndicateId'
      }).value || this.model.get('syndicateId') || (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.id);
      if (syndicateId) {
        await svs.numbergames.accountSelector.setActiveAccount(syndicateId);
        this.model.set('syndicateId', parseInt(syndicateId, 10));
      }
    } catch (e) {
      svs.numbergames.game.logger.warn(e);
    }
    try {
      const syndicates = await svs.numbergames.accountSelector.getAccounts();
      this.syndicates = syndicates.filter(s => !s.isPermissionBlocked).map(s => ({
        syndicateId: s.id,
        syndicateName: s.name,
        playableAmount: s.balance
      }));
    } catch (e) {
      svs.numbergames.game.logger.warn(e);
    }
    this.render();
  },
  onAttach() {
    this.animations = svs.numbergames.game.animations.showHideView.animateShowHide({
      el: this.$el,
      callbackScope: this,
      onHide() {
        this.constructor.__super__.destroy.apply(this);
      }
    });
    this.animations.show();
  },
  onChangeTeam(view, event) {
    const selectedSyndicateId = event ? event.target.value : 'SPELKONTO';
    svs.numbergames.accountSelector.setActiveAccount(selectedSyndicateId);
  },
  updateSyndicate(syndicateId) {
    if (syndicateId === 'SPELKONTO') {
      this.model.set({
        syndicateId: 0
      });
    } else {
      this.model.set({
        syndicateId: parseInt(syndicateId, 10)
      });
    }
  },
  destroy() {
    this.animations.hide();
  },
  onDestroy() {
    svs.numbergames.accountSelector.off(this.accountSelectorEvents);
    this.model.set('syndicateId', 0);
  }
});

 })(window);